import React, { useCallback, useEffect, useState } from "react";
import styled, { withTheme } from "styled-components";
import { AUDIT_TRAIL_MAX_LENGTH_FILTER_INPUT } from "../../../../modules/constants";
import PrimaryButton from "../../../ui-library/Buttons/PrimaryButton/PrimaryButton";
import CustomPopover from "../../../ui-library/CustomPopover/CustomPopover";
import LabelledInput from "../../../ui-library/LabelledInput/LabelledInput";

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const FormActionButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 20px;
`;

const SubjectAccountFilterForm = (props) => {
  const {
    show,
    onClose,
    onSubmit,
    currentFilterSubjectAccount,
    target,
    containerRef,
  } = props;

  const [filterSubjectAccount, setFilterSubjectAccount] = useState("");

  useEffect(() => {
    setFilterSubjectAccount(currentFilterSubjectAccount ?? "");
  }, [currentFilterSubjectAccount]);

  const handleOnClose = useCallback(() => {
    onClose();
    setFilterSubjectAccount(currentFilterSubjectAccount ?? "");
  }, [onClose, currentFilterSubjectAccount]);

  const onKeyDown = (event) => {
    if (event.key === "Enter") {
      onSubmit(filterSubjectAccount);
    }
  };

  return (
    <CustomPopover
      show={show}
      target={target}
      container={containerRef}
      onClose={handleOnClose}
      title="Filter by"
    >
      <FormContainer data-testid="subject-account-filter-form">
        <LabelledInput
          title="Subject Account"
          value={filterSubjectAccount}
          autoFocus={true}
          type="text"
          onChange={(e) =>
            e.target.value.length <= AUDIT_TRAIL_MAX_LENGTH_FILTER_INPUT &&
            setFilterSubjectAccount(e.target.value)
          }
          data-testid="atf-subject-account-input"
          onKeyDown={onKeyDown}
        />
        <FormActionButtonsContainer>
          <PrimaryButton
            data-testid="subject-account-filter-modal-submit-button"
            size="sm"
            onClick={() => {
              onSubmit(filterSubjectAccount);
            }}
          >
            Apply
          </PrimaryButton>
        </FormActionButtonsContainer>
      </FormContainer>
    </CustomPopover>
  );
};

export default withTheme(SubjectAccountFilterForm);
